import { translate } from 'javascripts/translations/i18n';
import {
  BASIC_PLAN_ID,
  ELITE_PLAN_ID,
  ITUNES_PLAN_ID,
  PREMIUM_PLAN_ID,
  PRO_PLAN_ID,
} from '../constants';

export const BILLING_CYCLE_AGNOSTIC_PLAN_IDS = [ITUNES_PLAN_ID, BASIC_PLAN_ID];

export const ANNUAL = 'ANNUAL';
export const MONTHLY = 'MONTHLY';
const ITUNES_PLAN = {
  name: translate('billing.itunesPlan'),
  type: ITUNES_PLAN_ID,
  testId: 'itunes',
  cycleTag: translate('billing.card.monthlyTag'),
  userCount: translate('billing.card.userIncludes'),
  featureHeader: translate('billing.card.eliteFeaturesHeader'),
  features: [
    translate('billing.card.videoWalkthrough'),
    translate('billing.card.paymentProcessing'),
    translate('billing.card.documentSigning'),
    translate('billing.card.websiteShowcaseWidget'),
    translate('billing.card.reviews'),
  ],
} as const;
const BASIC_PLAN = {
  name: translate('billing.basicPlan'),
  type: BASIC_PLAN_ID,
  testId: 'basic',
  featureHeader: translate('billing.card.keyFeatures'),
  features: [translate('billing.card.tenProjects')],
} as const;

// V3
const PRO_PLAN_BASE = {
  name: translate('billing.proPlan'),
  type: PRO_PLAN_ID,
  testId: 'pro',
  userCount: translate('billing.card.userIncludes'),
  featureHeader: translate('billing.card.keyFeatures'),
  features: [
    translate('billing.card.unlimitedPhotoStorage'),
    translate('billing.card.unlimitedProjects'),
    translate('billing.card.pdfReports'),
    translate('billing.card.checklists'),
    translate('billing.card.fiveMinuteVideoCapture'),
    translate('billing.card.beforeAfters'),
    translate('billing.card.unlimitedDocumentStorage'),
    translate('billing.card.unlimitedIntegrations'),
  ],
} as const;

// V3
const PRO_MONTHLY_PLAN = {
  ...PRO_PLAN_BASE,
  cycleTag: translate('billing.card.monthlyTag'),
} as const;

// V3
const PRO_ANNUAL_PLAN = {
  ...PRO_PLAN_BASE,
  cycleTag: translate('billing.card.yearlyTag'),
} as const;

// V1
const PRO_PLAN_LEGACY_BASE = {
  name: translate('billing.proPlan'),
  type: PRO_PLAN_ID,
  testId: 'pro',
  featureHeader: translate('billing.card.keyFeatures'),
  features: [
    translate('billing.card.unlimitedPhotoStorage'),
    translate('billing.card.unlimitedProjects'),
    translate('billing.card.pdfReports'),
    translate('billing.card.checklists'),
    translate('billing.card.fiveMinuteVideoCapture'),
    translate('billing.card.beforeAfters'),
    translate('billing.card.unlimitedDocumentStorage'),
    translate('billing.card.unlimitedIntegrations'),
    translate('billing.card.collaboratorAccess'),
  ],
} as const;

// V2
const PRO_MONTHLY_PLAN_V2 = {
  ...PRO_PLAN_LEGACY_BASE,
  userCount: translate('billing.card.userIncludes'),
  cycleTag: translate('billing.card.monthlyTag'),
} as const;

// V2
const PRO_ANNUAL_PLAN_V2 = {
  ...PRO_PLAN_LEGACY_BASE,
  userCount: translate('billing.card.userIncludes'),
  cycleTag: translate('billing.card.yearlyTag'),
};

// V1
const PRO_MONTHLY_PLAN_V1 = {
  ...PRO_PLAN_LEGACY_BASE,
  userCount: translate('billing.card.singleUser'),
  cycleTag: translate('billing.card.monthlyTag'),
} as const;

// V1
const PRO_ANNUAL_PLAN_V1 = {
  ...PRO_PLAN_LEGACY_BASE,
  userCount: translate('billing.card.singleUser'),
  cycleTag: translate('billing.card.yearlyTag'),
} as const;

// V3
const PREMIUM_PLAN_BASE = {
  name: translate('billing.premiumPlan'),
  type: PREMIUM_PLAN_ID,
  testId: 'premium',
  userCount: translate('billing.card.userIncludes'),
  featureHeader: translate('billing.card.premiumFeaturesHeader'),
  features: [
    translate('billing.card.aiReporting'),
    translate('billing.card.projectTemplates'),
    translate('billing.card.reportTemplates'),
    translate('billing.card.checklistTemplates'),
    translate('billing.card.videoCapture'),
    translate('billing.card.photoWatermark'),
    translate('billing.card.companyDashboard'),
    translate('billing.card.collaboratorAccess'),
  ],
} as const;

// V3
const PREMIUM_MONTHLY_PLAN = {
  ...PREMIUM_PLAN_BASE,
  cycleTag: translate('billing.card.monthlyTag'),
} as const;

// V3
const PREMIUM_ANNUAL_PLAN = {
  ...PREMIUM_PLAN_BASE,
  cycleTag: translate('billing.card.yearlyTag'),
} as const;

const PREMIUM_PLAN_LEGACY_BASE = {
  name: translate('billing.premiumPlan'),
  type: PREMIUM_PLAN_ID,
  testId: 'premium',
  featureHeader: translate('billing.card.premiumFeaturesHeader'),
  features: [
    translate('billing.card.videoWalkthrough'),
    translate('billing.card.paymentProcessing'),
    translate('billing.card.aiReporting'),
    translate('billing.card.projectTemplates'),
    translate('billing.card.reportTemplates'),
    translate('billing.card.checklistTemplates'),
    translate('billing.card.videoCapture'),
    translate('billing.card.photoWatermark'),
    translate('billing.card.companyDashboard'),
    translate('billing.card.collaboratorAccess'),
  ],
} as const;

// V2
const PREMIUM_MONTHLY_PLAN_V2 = {
  ...PREMIUM_PLAN_LEGACY_BASE,
  userCount: translate('billing.card.userIncludes'),
  cycleTag: translate('billing.card.monthlyTag'),
} as const;

// V2
const PREMIUM_ANNUAL_PLAN_V2 = {
  ...PREMIUM_PLAN_LEGACY_BASE,
  userCount: translate('billing.card.userIncludes'),
  cycleTag: translate('billing.card.yearlyTag'),
} as const;

// V1
const PREMIUM_MONTHLY_PLAN_V1 = {
  ...PREMIUM_PLAN_LEGACY_BASE,
  userCount: translate('billing.card.singleUser'),
  cycleTag: translate('billing.card.monthlyTag'),
} as const;

// V1
const PREMIUM_ANNUAL_PLAN_V1 = {
  ...PREMIUM_PLAN_LEGACY_BASE,
  userCount: translate('billing.card.singleUser'),
  cycleTag: translate('billing.card.yearlyTag'),
} as const;

const ELITE_MONTHLY_PLAN = {
  name: translate('billing.elitePlan'),
  type: ELITE_PLAN_ID,
  testId: 'elite',
  userCount: translate('billing.card.userIncludes'),
  cycleTag: translate('billing.card.monthlyTag'),
  featureHeader: translate('billing.card.eliteFeaturesHeader'),
  features: [
    translate('billing.card.videoWalkthrough'),
    translate('billing.card.paymentProcessing'),
    translate('billing.card.documentSigning'),
    translate('billing.card.websiteShowcaseWidget'),
    translate('billing.card.reviews'),
  ],
} as const;
const ELITE_ANNUAL_PLAN = {
  name: translate('billing.elitePlan'),
  type: ELITE_PLAN_ID,
  testId: 'elite',
  userCount: translate('billing.card.userIncludes'),
  cycleTag: translate('billing.card.yearlyTag'),
  featureHeader: translate('billing.card.eliteFeaturesHeader'),
  features: [
    translate('billing.card.videoWalkthrough'),
    translate('billing.card.paymentProcessing'),
    translate('billing.card.documentSigning'),
    translate('billing.card.websiteShowcaseWidget'),
    translate('billing.card.reviews'),
  ],
} as const;
// This will be cleaned up when Elite plan FF is removed
export const PLANS_BY_ID_AND_CYCLE = {
  [`${ANNUAL}_${PRO_PLAN_ID}`]: PRO_ANNUAL_PLAN,
  [`${MONTHLY}_${PRO_PLAN_ID}`]: PRO_MONTHLY_PLAN,
  [`${ANNUAL}_${PRO_PLAN_ID}_v2`]: PRO_ANNUAL_PLAN_V2,
  [`${MONTHLY}_${PRO_PLAN_ID}_v2`]: PRO_MONTHLY_PLAN_V2,
  [`${ANNUAL}_${PRO_PLAN_ID}_v1`]: PRO_ANNUAL_PLAN_V1,
  [`${MONTHLY}_${PRO_PLAN_ID}_v1`]: PRO_MONTHLY_PLAN_V1,
  [`${ANNUAL}_${PREMIUM_PLAN_ID}`]: PREMIUM_ANNUAL_PLAN,
  [`${MONTHLY}_${PREMIUM_PLAN_ID}`]: PREMIUM_MONTHLY_PLAN,
  [`${ANNUAL}_${PREMIUM_PLAN_ID}_v2`]: PREMIUM_ANNUAL_PLAN_V2,
  [`${MONTHLY}_${PREMIUM_PLAN_ID}_v2`]: PREMIUM_MONTHLY_PLAN_V2,
  [`${ANNUAL}_${PREMIUM_PLAN_ID}_v1`]: PREMIUM_ANNUAL_PLAN_V1,
  [`${MONTHLY}_${PREMIUM_PLAN_ID}_v1`]: PREMIUM_MONTHLY_PLAN_V1,
  [`${ANNUAL}_${ELITE_PLAN_ID}`]: ELITE_ANNUAL_PLAN,
  [`${MONTHLY}_${ELITE_PLAN_ID}`]: ELITE_MONTHLY_PLAN,
  [ITUNES_PLAN_ID]: ITUNES_PLAN,
  [BASIC_PLAN.type]: BASIC_PLAN,
};
export const PLANS = {
  BASIC_PLAN,
  ITUNES_PLAN,
  PRO_MONTHLY_PLAN,
  PRO_ANNUAL_PLAN,
  PRO_ANNUAL_PLAN_V2,
  PRO_MONTHLY_PLAN_V2,
  PREMIUM_MONTHLY_PLAN,
  PREMIUM_ANNUAL_PLAN,
  PREMIUM_MONTHLY_PLAN_V2,
  PREMIUM_ANNUAL_PLAN_V2,
  ELITE_MONTHLY_PLAN,
  ELITE_ANNUAL_PLAN,
};
